angular.module 'zc.master.campaigns'

.config ($stateProvider) ->
  $stateProvider
  .state 'admin.master.campaigns',
    url: '/campaigns'
    views:
      'content@':
        templateUrl: '/templates/master.campaigns/list.html'
        controller: 'MasterCampaignsCtrl'
        resolve:
          templates: (Template, $stateParams) ->
            # FIXME: projectid hardcoded
            Template.all(1)
          currentUser: (Devise) ->
            Devise.getCurrentUser()



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.campaigns/routes.js.coffee